<template>
  <div id="paint-finish">
    <b-card-text>
      <b-row>
        <b-col sm="12" lg="8">
          <h4>Primary</h4>
          <div class="team-colors">
            <table :class="team" class="table-responsive">
              <tr v-for="i in ['A', 'B', 'C', 'D', 'E', 'F', 'G']" v-bind:key='i'>
                <td
                  v-for="j in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                  :key='j'
                  :class="{selected: input.primary.color.value == i + j}"
                  class="rounded"
                >
                  <div class="btn-group btn-group-toggle">
                    <label class="btn btn-secondary" :class="i + j">
                      <input
                        type="radio"
                        :value="i + j"
                        v-model="input.primary.color.value"
                      >
                    </label>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </b-col>
        <b-col sm="12" lg="4" :class="{'d-none': !paintableDecal()}">
          <b-form-input
            v-model="filter.primary"
            placeholder="Filter..."
            class="mb-2"
          ></b-form-input>
          <b-form-select
            v-model="input.primary.item.value"
            :options="filterItems(filter.primary, items)"
            class="d-block"
            :select-size="8"
          ></b-form-select>
        </b-col>
      </b-row>
    </b-card-text>
    <b-card-text>
      <b-row>
        <b-col sm="12" lg="8">
          <h4>Accent</h4>
          <div class="team-colors">
            <table class="Accent table-responsive">
              <tr v-for="i in ['A', 'B', 'C', 'D', 'E', 'F', 'G']" v-bind:key='i'>
                <td
                  v-for="j in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]"
                  :key='j'
                  :class="{selected: input.accent.color.value == i + j}"
                  class="rounded"
                >
                  <div class="btn-group btn-group-toggle">
                    <label class="btn btn-secondary" :class="i + j">
                      <input
                        type="radio"
                        :value="i + j"
                        v-model="input.accent.color.value"
                      >
                    </label>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </b-col>
        <b-col sm="12" lg="4" :class="{'d-none': !paintableDecal()}">
          <b-form-input
            v-model="filter.accent"
            placeholder="Filter..."
            class="mb-2"
          ></b-form-input>
          <b-form-select
            v-model="input.accent.item.value"
            :options="filterItems(filter.accent, items)"
            class="d-block"
            :select-size="8"
          ></b-form-select>
        </b-col>
      </b-row>
    </b-card-text>
  </div>
</template>

<script>
require('../assets/css/colors.css');

export default {
  name: 'PaintFinishTab',
  data() {
    return {
      filter: {primary: '', accent: ''}
    }
  },
  props: {
    team: String,
    input: Object,
    items: Array,
    decal: Object
  },
  methods: {
    filterItems: function(needle, haystack) {
			return haystack.filter(i => i.toUpperCase().includes(needle.toUpperCase()))
    },
    paintableDecal: function() {
      var paintable = true;
      var primary = this.input.primary.item;
      var accent = this.input.accent.item;
      var decal = this.decal;

      if (decal.name != 'None') {
        if (decal.quality == 'Black Market' ||
            !decal.name.includes(': ')) {
          paintable = false;
        }
      }

      if (paintable) {
        if (primary.value == '') {
          primary.value = 'Glossy'
        }
        if (accent.value == '') {
          accent.value = 'Glossy'
        }
      } else {
        primary.value = '';
        accent.value = '';
      }

      return paintable;
    }
  }
}
</script>

<style scoped>
.overflow-auto {
  max-height: 10em;
}

#paint-finish .selected {
  background-color: black;
}

#paint-finish .selected .btn {
  border-color: white;
}

#paint-finish .team-colors table {
  border-spacing: 0;
  line-height: 1;
}

#paint-finish .team-colors table td {
  padding: 0;
}

#paint-finish .team-colors table .btn {
  padding: 0;
  height: 1.5em;
  width: 1.5em;
  margin: 2px;
  min-height: 0;
  max-width: 100%;
}
</style>